import { useQuery } from "@tanstack/react-query";
import { getUserXp, type UserXpResponse } from "../services/naraDoor";

export function useUserXp() {
  return useQuery<UserXpResponse>({
    queryKey: ["userXp"],
    queryFn: getUserXp,
    staleTime: 1000 * 60, // 1 minute
  });
}
